// src/components/frameworkDefinition.js

// Complete definition of all 43 active framework components
// Based on Pallium 0.7 specification

export const ALL_FRAMEWORK_COMPONENTS = [
  // Part 1: Account Health Assessment & Monitoring (26%, 8 active of 10 total)
  { id: 'stakeholder_satisfaction', name: 'Stakeholder Satisfaction Assessment', partNumber: 1, weight: 3.25, deferred: false },
  { id: 'relationship_depth', name: 'Relationship Depth Analysis', partNumber: 1, weight: 3.25, deferred: false },
  { id: 'communication_quality', name: 'Communication Quality Assessment', partNumber: 1, weight: 3.25, deferred: false },
  { id: 'kpi_achievement', name: 'KPI Achievement Assessment', partNumber: 1, weight: 3.25, deferred: true },
  { id: 'roi_realization', name: 'ROI Realization Validation', partNumber: 1, weight: 3.25, deferred: false },
  { id: 'service_level_performance', name: 'Service Level Performance', partNumber: 1, weight: 3.25, deferred: true },
  { id: 'value_perception', name: 'Value Perception Confirmation', partNumber: 1, weight: 3.25, deferred: false },
  { id: 'churn_risk_indicator', name: 'Churn Risk Indicator Analysis', partNumber: 1, weight: 3.25, deferred: false },
  { id: 'contract_renewal_likelihood', name: 'Contract Renewal Likelihood', partNumber: 1, weight: 3.25, deferred: false },
  { id: 'competitive_threat', name: 'Competitive Threat Assessment', partNumber: 1, weight: 3.25, deferred: false },
  
  // Part 2: Growth & Expansion Development (26%, 11 active)
  { id: 'upsell_opportunity', name: 'Cross-Sell/Up-Sell Opportunity Recognition', partNumber: 2, weight: 2.36, deferred: false },
  { id: 'white_space_analysis', name: 'Current Account Opportunity/White-Space Analysis Quality', partNumber: 2, weight: 2.36, deferred: false },
  { id: 'business_case_development', name: 'Business Case Development', partNumber: 2, weight: 2.36, deferred: false },
  { id: 'timing_assessment', name: 'Timing Assessment Accuracy', partNumber: 2, weight: 2.36, deferred: false },
  { id: 'account_strategy', name: 'Account Strategy Development', partNumber: 2, weight: 2.36, deferred: false },
  { id: 'stakeholder_influence_mapping', name: 'Stakeholder Influence Mapping', partNumber: 2, weight: 2.36, deferred: false },
  { id: 'competitive_positioning', name: 'Competitive Positioning Strategy', partNumber: 2, weight: 2.36, deferred: false },
  { id: 'resource_allocation_planning', name: 'Resource Allocation Planning', partNumber: 2, weight: 2.36, deferred: false },
  { id: 'proposal_quality', name: 'Proposal Quality & Customization', partNumber: 2, weight: 2.36, deferred: false },
  { id: 'stakeholder_buy_in', name: 'Stakeholder Buy-in Generation', partNumber: 2, weight: 2.36, deferred: false },
  { id: 'timeline_planning', name: 'Timeline & Implementation Planning', partNumber: 2, weight: 2.36, deferred: false },
  
  // Part 3: Relationship Management & Stakeholder Engagement (20%, 8 active)
  { id: 'executive_relationship', name: 'Executive Relationship Quality', partNumber: 3, weight: 2.5, deferred: false },
  { id: 'operational_relationship', name: 'Operational Relationship Depth', partNumber: 3, weight: 2.5, deferred: false },
  { id: 'cross_functional_engagement', name: 'Cross-Functional Engagement', partNumber: 3, weight: 2.5, deferred: false },
  { id: 'relationship_sophistication', name: 'Relationship Sophistication', partNumber: 3, weight: 2.5, deferred: false },
  { id: 'proactive_communication', name: 'Proactive Communication Quality', partNumber: 3, weight: 2.5, deferred: false },
  { id: 'meeting_facilitation', name: 'Meeting Facilitation Effectiveness', partNumber: 3, weight: 2.5, deferred: false },
  { id: 'information_sharing', name: 'Information Sharing Value', partNumber: 3, weight: 2.5, deferred: false },
  { id: 'crisis_communication', name: 'Communication Intelligence (Crisis & Escalation)', partNumber: 3, weight: 2.5, deferred: false },
  
  // Part 4: Issue Resolution & Client Advocacy (15%, 6 active)
  { id: 'issue_identification_proactivity', name: 'Issue Identification Proactivity', partNumber: 4, weight: 2.5, deferred: false },
  { id: 'prevention_strategy', name: 'Prevention Strategy Implementation', partNumber: 4, weight: 2.5, deferred: false },
  { id: 'early_warning_system', name: 'Early Warning System Effectiveness', partNumber: 4, weight: 2.5, deferred: false },
  { id: 'response_time_management', name: 'Response Time & Urgency Management', partNumber: 4, weight: 2.5, deferred: false },
  { id: 'solution_quality', name: 'Solution Quality & Permanence', partNumber: 4, weight: 2.5, deferred: false },
  { id: 'client_satisfaction_resolution', name: 'Client Satisfaction with Resolution', partNumber: 4, weight: 2.5, deferred: false },
  
  // Part 5: Strategic Value Creation & Innovation (10%, 7 active)
  { id: 'market_intelligence', name: 'Market Intelligence Provision', partNumber: 5, weight: 1.43, deferred: false },
  { id: 'best_practice_sharing', name: 'Best Practice Sharing', partNumber: 5, weight: 1.43, deferred: false },
  { id: 'trend_analysis', name: 'Trend Analysis Application', partNumber: 5, weight: 1.43, deferred: false },
  { id: 'value_added_consultation', name: 'Value-Added Consultation', partNumber: 5, weight: 1.43, deferred: false },
  { id: 'collaborative_solution', name: 'Collaborative Solution Development', partNumber: 5, weight: 1.43, deferred: false },
  { id: 'pilot_program', name: 'Pilot Program Facilitation', partNumber: 5, weight: 1.43, deferred: false },
  { id: 'innovation_facilitation', name: 'Innovation Facilitation', partNumber: 5, weight: 1.43, deferred: false },
  
  // Part 6: Account Planning & Strategic Coordination (3%, 3 active)
  { id: 'cross_functional_team_coordination', name: 'Cross-Functional Team Coordination', partNumber: 6, weight: 1.0, deferred: false },
  { id: 'resource_allocation_optimization', name: 'Resource Allocation Optimization', partNumber: 6, weight: 1.0, deferred: false },
  { id: 'strategic_priority_alignment', name: 'Strategic Priority Alignment', partNumber: 6, weight: 1.0, deferred: false }
];

export const FRAMEWORK_PARTS = [
  {
    number: 1,
    name: 'Account Health and Monitoring',
    weight: 26,
    totalComponents: 10,
    activeComponents: 8, // Excluding 2 deferred
    description: 'Relationship quality, business performance, and risk assessment'
  },
  {
    number: 2,
    name: 'Growth and Expansion',
    weight: 26,
    totalComponents: 11,
    activeComponents: 11,
    description: 'Opportunity identification, strategic planning, and expansion execution'
  },
  {
    number: 3,
    name: 'Relationship and Trust Building',
    weight: 20,
    totalComponents: 8,
    activeComponents: 8,
    description: 'Multi-level relationships and communication excellence'
  },
  {
    number: 4,
    name: 'Issue Resolution',
    weight: 15,
    totalComponents: 6,
    activeComponents: 6,
    description: 'Problem prevention and resolution excellence'
  },
  {
    number: 5,
    name: 'Strategic Value and Innovation',
    weight: 10,
    totalComponents: 7,
    activeComponents: 7,
    description: 'Industry expertise and innovation partnership'
  },
  {
    number: 6,
    name: 'Strategic Planning and Forecasting',
    weight: 3,
    totalComponents: 3,
    activeComponents: 3,
    description: 'Internal alignment and resource coordination'
  }
];

